import { render, staticRenderFns } from "./SupplierMaintenanceList.vue?vue&type=template&id=652e75d2&scoped=true"
import script from "./SupplierMaintenanceList.vue?vue&type=script&lang=js"
export * from "./SupplierMaintenanceList.vue?vue&type=script&lang=js"
import style0 from "./SupplierMaintenanceList.vue?vue&type=style&index=0&id=652e75d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e75d2",
  null
  
)

export default component.exports